"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProductSellType = exports.BlazeMetaDataReservedKeys = exports.CannabinoidReservedKeys = exports.TerpeneReservedKeys = exports.MetaDataReservedKeys = void 0;
var MetaDataReservedKeys;
(function (MetaDataReservedKeys) {
    MetaDataReservedKeys["THC"] = "thc";
    MetaDataReservedKeys["CBD"] = "cbd";
    MetaDataReservedKeys["MAX_CBD"] = "maxCBD";
    MetaDataReservedKeys["MIN_CBD"] = "minCBD";
    MetaDataReservedKeys["MAX_THC"] = "maxTHC";
    MetaDataReservedKeys["MIN_THC"] = "minTHC";
    MetaDataReservedKeys["SHOW_MAX_MIN"] = "showMaxMin";
    MetaDataReservedKeys["UNIT"] = "unit";
    MetaDataReservedKeys["PACKAGE_DATE"] = "packageDate";
})(MetaDataReservedKeys || (exports.MetaDataReservedKeys = MetaDataReservedKeys = {}));
var TerpeneReservedKeys;
(function (TerpeneReservedKeys) {
    TerpeneReservedKeys["ALPHA_CEDRENE"] = "ALPHA-CEDRENE";
    TerpeneReservedKeys["ALPHA_SANTALENE"] = "ALPHA-SANTALENE";
    TerpeneReservedKeys["ALPHA_BISABOLOL"] = "ALPHA-BISABOLOL";
    TerpeneReservedKeys["ALPHA_HUMULENE"] = "ALPHA-HUMULENE";
    TerpeneReservedKeys["ALPHA_PINENE"] = "ALPHA-PINENE";
    TerpeneReservedKeys["ALPHA_TERPINEOL"] = "ALPHA-TERPINEOL";
    TerpeneReservedKeys["BETA_CARYOPHYLLENE"] = "BETA-CARYOPHYLLENE";
    TerpeneReservedKeys["BETA_MYRCENE"] = "BETA-MYRCENE";
    TerpeneReservedKeys["BETA_OCIMENE"] = "BETA-OCIMENE";
    TerpeneReservedKeys["BETA_PINENE"] = "BETA-PINENE";
    TerpeneReservedKeys["BISABOLOL"] = "BISABOLOL";
    TerpeneReservedKeys["CAMPHENE"] = "CAMPHENE";
    TerpeneReservedKeys["CARYOPHYLLENE"] = "CARYOPHYLLENE";
    TerpeneReservedKeys["CEDRENE"] = "CEDRENE";
    TerpeneReservedKeys["CYMENE"] = "CYMENE";
    TerpeneReservedKeys["DELTA_LIMONENE"] = "DELTA-LIMONENE";
    TerpeneReservedKeys["EUCALYPTOL"] = "EUCALYPTOL";
    TerpeneReservedKeys["EUDESMOLS"] = "EUDESMOLS";
    TerpeneReservedKeys["FARNESENE"] = "FARNESENE";
    TerpeneReservedKeys["FARNESOL"] = "FARNESOL";
    TerpeneReservedKeys["FENCHOL"] = "FENCHOL";
    TerpeneReservedKeys["FENCHONE"] = "FENCHONE";
    TerpeneReservedKeys["GERANIOL"] = "GERANIOL";
    TerpeneReservedKeys["GERMACRENE"] = "GERMACRENE";
    TerpeneReservedKeys["GUAIOL"] = "GUAIOL";
    TerpeneReservedKeys["HUMULENE"] = "HUMULENE";
    TerpeneReservedKeys["LIMONENE"] = "LIMONENE";
    TerpeneReservedKeys["LINALOOL"] = "LINALOOL";
    TerpeneReservedKeys["MYRCENE"] = "MYRCENE";
    TerpeneReservedKeys["NEROLIDOL"] = "NEROLIDOL";
    TerpeneReservedKeys["OCIMENE"] = "OCIMENE";
    TerpeneReservedKeys["PARA_CYMENENE"] = "PARA-CYMENENE";
    TerpeneReservedKeys["PINENE"] = "PINENE";
    TerpeneReservedKeys["PHYTOL"] = "PHYTOL";
    TerpeneReservedKeys["SELINADIENES"] = "SELINADIENES";
    TerpeneReservedKeys["TERPINENE"] = "TERPINENE";
    TerpeneReservedKeys["TERPINEOL"] = "TERPINEOL";
    TerpeneReservedKeys["TERPINOLENE"] = "TERPINOLENE";
    TerpeneReservedKeys["THUJONE"] = "THUJONE";
    TerpeneReservedKeys["TRANS_CARYOPHYLLENE"] = "TRANS-CARYOPHYLLENE";
    TerpeneReservedKeys["TRANS_NEROLIDOL"] = "TRANS-NEROLIDOL";
    TerpeneReservedKeys["TRANS_OCIMENE"] = "TRANS-OCIMENE";
})(TerpeneReservedKeys || (exports.TerpeneReservedKeys = TerpeneReservedKeys = {}));
var CannabinoidReservedKeys;
(function (CannabinoidReservedKeys) {
    CannabinoidReservedKeys["DELTA_9_TETRAHYDROCANNABINOL_THC"] = "THC (\u03949-Tetrahydrocannabinol)";
    CannabinoidReservedKeys["DELTA_9_TETRAHYDROCANNABIVARIN_THCV"] = "THCV (\u03949-Tetrahydrocannabivarin)";
    CannabinoidReservedKeys["DELTA_9_TETRAHYDROCANNABINOLIC_ACID_THCA"] = "THCA (\u03949-Tetrahydrocannabinolic acid)";
    CannabinoidReservedKeys["DELTA_8_TETRAHYDROCANNABINOL_THC"] = "\u03948-THC (\u03948-Tetrahydrocannabinol)";
    CannabinoidReservedKeys["DELTA_8_TETRAHYDROCANNABINOLIC_ACID_THCA"] = "\u03948-THCA (\u03948-Tetrahydrocannabinolic acid)";
    CannabinoidReservedKeys["CANNABIDIOL_CBD"] = "CBD (Cannabidiol)";
    CannabinoidReservedKeys["CANNABINOL_CBN"] = "CBN (Cannabinol)";
    CannabinoidReservedKeys["CANNABICHROMENE_CBC"] = "CBC (Cannabichromene)";
    CannabinoidReservedKeys["CANNABIGEROL_CBG"] = "CBG (Cannabigerol)";
    CannabinoidReservedKeys["CANNABIDIOLIC_ACID_SYNTHASE_CBDA"] = "CBDA (Cannabidiolic acid synthase)";
    CannabinoidReservedKeys["CANNABIDIVARIN_CBDV"] = "CBDV (Cannabidivarin)";
    CannabinoidReservedKeys["CANNABIGEROLIC_ACID_CBGA"] = "CBGA (Cannabigerolic acid)";
    CannabinoidReservedKeys["CANNABICHROMENENIC_ACID_CBCA"] = "CBCA (Cannabichromenenic acid)";
    CannabinoidReservedKeys["CANNABIGEROVARINIC_ACID_CBGVA"] = "CBGVA (Cannabigerovarinic acid)";
    CannabinoidReservedKeys["TETRAHYDROCANABIVARINIC_ACID_THCVA"] = "THCVA (Tetrahydrocanabivarinic acid)";
    CannabinoidReservedKeys["CANNABIDIVARINIC_ACID_CBDVA"] = "CBDVA (Cannabidivarinic acid)";
    CannabinoidReservedKeys["CANNABICHROMEVARINIC_ACID_CBCVA"] = "CBCVA (Cannabichromevarinic acid)";
})(CannabinoidReservedKeys || (exports.CannabinoidReservedKeys = CannabinoidReservedKeys = {}));
var BlazeMetaDataReservedKeys;
(function (BlazeMetaDataReservedKeys) {
    BlazeMetaDataReservedKeys["SELL_TYPE"] = "sellType";
    BlazeMetaDataReservedKeys["AVAILABLE_ONLINE"] = "availableOnline";
})(BlazeMetaDataReservedKeys || (exports.BlazeMetaDataReservedKeys = BlazeMetaDataReservedKeys = {}));
var EProductSellType;
(function (EProductSellType) {
    EProductSellType["RECREATIONAL"] = "recreational";
    EProductSellType["MEDICINAL"] = "medicinal";
    EProductSellType["BOTH"] = "both";
})(EProductSellType || (exports.EProductSellType = EProductSellType = {}));
//# sourceMappingURL=metaData.js.map